
<script>
  import {_} from 'svelte-i18n'
  import { fade } from 'svelte/transition';
  import Tailwind from '../Tailwind.svelte';
  import { onMount } from 'svelte';
  import { sessionData } from '../stores';
  import { Motion, M } from 'svelte-motion';
  import { push } from 'svelte-spa-router';
  import { PLAYER_STATE } from '../chess-console-app/ChessConsoleAppState';
  import { container, itemC } from './animations.js';
  import { auth } from '../firebase'
  import { showStartIntercom } from '../lib.js'

  export let visible = false;

  const fadeTransition = { duration: 200, easing: cubicInOut };
  function cubicInOut(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  }

  function toggleSidebar() {
    $sessionData.sidebar = !$sessionData.sidebar;
    visible = $sessionData.sidebar;
  }
  function signOut(event) {
    event.preventDefault()
    auth.signOut();
    window.location = '/';
  }

  function mkHref(route) {
    return route.startsWith('http') ? route : ('/#/' + route);
  }

  let socials = [
    { name: 'Instagram', url: 'https://www.instagram.com/gambit_app/', icon: '/assets/images/icons/instagram.svg' },
    { name: 'Facebook', url: 'https://www.facebook.com/gambitai', icon: '/assets/images/icons/facebook.svg' },
    { name: 'X', url: 'https://twitter.com/gambit_ai', icon: '/assets/images/icons/logo.svg' },
    { name: 'LinkedIn', url: 'https://www.linkedin.com/company/gambit-ai/', icon: '/assets/images/icons/linkedin.svg' }
  ];

  const menuItems =
    [ { label: 'play'
      , icon: 'assets/images/menu_icons/play.svg'
      , route: 'Play' }

    , { label: 'wallet'
      , icon: 'assets/images/menu_icons/wallet.svg'
      , route: 'wallet' }

    , { label: 'terms of use'
      , icon: 'assets/images/menu_icons/terms.svg'
      , route: 'terms'
      , openNewPage: true }

    , { label: 'privacy policy'
      , icon: 'assets/images/menu_icons/privacy.svg'
      , route: 'privacy'
      , openNewPage: true }

    , { label: 'about'
      , icon: 'assets/images/menu_icons/about.svg'
      , route: 'https://company.gambit.ai'
        , openNewPage: true }

    , { label: 'support'
      , icon: 'assets/images/menu_icons/support.svg'
      , route: () => {
        let e
        if (e = document.querySelector('#intercom-container'))
          e.style.visibility = 'visible';
        showStartIntercom($sessionData.user.uid)

      } }

    ];
</script>

<Tailwind />
{#if sessionData.playerState !== PLAYER_STATE.puzzle}
<div class="fixed top-0 right-0 z-[60]">
  <button
    on:click={toggleSidebar}
    class="fixed z-[500] top-6 right-4 w-12 h-12 flex items-center justify-center"
    aria-label={visible ? "Close menu" : "Open menu"}
  >
    {#if visible}
      <img
        transition:fade={fadeTransition}
        src="close_light.svg"
        alt="Close menu"
        class="w-full h-full absolute no-select"
      />
    {:else}
      <img
        transition:fade={fadeTransition}
        src="menu.svg"
        alt="Open menu"
        class="w-full h-full absolute no-select"
      />
    {/if}
  </button>
  <div class="sidebar {visible ? 'active' : 'inactive'}">
    <div class="sidebar-content h-full w-full rounded-l shadow-lg p-6">
      <Motion initial="hidden" animate={visible ? "show" : "hidden"} variants={container}>
        <div class="mt-24 flex flex-col">
          {#each menuItems as item}

            {#if typeof item.route == 'string' }
              <a
                href={mkHref(item.route)}
                target={item.openNewPage ? '_blank' : undefined}
                variants={itemC}
                class="flex flex-row gap-x-4 mb-6"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                animate={{ scale: 1 }}
              >
                <img class="w-8 self-center no-select" src={item.icon} alt={item.label} />
                <span class="font-brown text-xl text-white align-middle no-select">{item.label}</span>
              </a>
            {:else if typeof item.route == 'function' }
              <button on:click={item.route} class="flex flex-row gap-x-4 mb-6">
                <img src={item.icon} class="w-8" alt={item.icon} />
                <h1 class="font-brown text-xl">{item.label}</h1>
              </button>
            {/if}
          {/each}

        </div>
      </Motion>

      <div class="sidebar-bottom">

        <button on:click={signOut} class="flex flex-row gap-x-4 z-50 mr-4 text-[#343434] text-2xl font-brown">
          <img src={"logout.svg"} class="w-8" alt='logout.svg' />
          <h1 class=" text-2xl font-brown">{$_("common.signOut")}</h1>
        </button>

        <div class="socials-style">
          {#each socials as social}
            <a href="{social.url}" class="flex items-center" target="_blank" rel="noopener noreferrer">
              <img src="{social.icon}" alt="{social.name}" class="h-6 w-6 no-select" />
            </a>
          {/each}
        </div>
      </div>
    </div>
  </div>
</div>
{/if}



<style>
  .no-select { user-select: none; }

  .active {
    transform: translateX(0);
  }

  .inactive {
    transform: translateX(120%);
  }

  .sidebar {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 300px;
    z-index: 400;
    transition: transform 0.3s ease-in-out;
  }

  .sidebar-content {
    height: 100%;
    box-shadow: -6px 5px 24px 9px rgba(0,0,0,0.66);
    overflow-y: auto;
    background-color: #262626;
  }

  :global(.bg-space-gray) {
    background-color: #2F3640;
  }
  :global(body) {
    overflow-x: hidden;
  }

  .sidebar-bottom {
    bottom: 0;
    left: 0;
    right: 0;
    position: absolute;
    padding: 0 2rem 2rem 2rem;

    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  .socials-style {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
</style>
